const $ = jQuery.noConflict();
import ProductGallery from './productGallery';

'use strict';
const VariantInfo = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	ajaxFinished: false,
	showLoading: false,
	defaultSku: '',
	defaultOldSkuString: '',
	defaultImage: '',
	defaultImageIsPlaceholder: false,
	placeholderImage: '',
	hasLifestyleImages: false, // Track if there are lifestyle/gallery images
	variantInfo: {},
	attributeValues: {},
	previousAttributes: [],
	lastChangedAttribute: null,
	preloadedImages: new Map(), // Cache for preloaded images
	imageQueue: [], // Queue for lazy loading images
	isProgrammaticClick: false, // Flag to track programmatic clicks
	compatibleAttributeValues: {}, // Store compatible values

	/** @description Initialize */
	init: ()=> {
		$('#main-attr-container').addClass('is-loading');
		VariantInfo.placeholderImage = window.fwsLocalized.themeRoot + '/src/assets/images/e-placeholder.png';
		VariantInfo.getVariantInfo();
		VariantInfo.addFilterListeners();
		VariantInfo.getActiveFilters();
		VariantInfo.getDefaults();
	},

	addFilterListeners: function() {
		const _this = this;

		$('.js-filter-option-radio .option__item').on('click', function() {
			// Skip if this is a programmatic click
			if (_this.isProgrammaticClick) return;

			const $label = $(this);
			const $input = $label.find('input[type="radio"]');
			_this.lastChangedAttribute = {
				key: $input.attr('name'),
				value: $input.val(),
			};
		});

		$('.js-filter-option:not([type="radio"])').on('click', function() {
			// Skip if this is a programmatic click
			if (_this.isProgrammaticClick) return;

			const name = $(this).data('attr');
			const spanSelection = $(this).find('.js-span-selection');
			if (spanSelection) {
				const value = spanSelection.data('value');
				if (value) {
					_this.lastChangedAttribute = {
						key: name,
						value: value,
					};
				}
			}
		});

		$('.js-product-attr-option-select').on('change', function() {
			// Skip if this is a programmatic change
			if (_this.isProgrammaticClick) return;

			_this.lastChangedAttribute = {
				key: $(this).data('attr'),
				value: $(this).val(),
			};
		});

		$('.js-filter-option').on('click', function() {
			if (_this.isProgrammaticClick) return;

			const $el = $(this);
			const attr = $el.data('attr');
			const value = $el.find('.js-span-selection').data('value');

			if (attr && value) {
				$(`.js-filter-option[data-attr="${attr}"]`).removeClass('is-selected is-hovered');
				$el.addClass('is-selected');
			}

			_this.previousAttributes = _this.getActiveFilters();
			_this.onFilterChange();
		});

		$('.js-filter-option').on('mouseenter', function() {
			if (_this.isProgrammaticClick) return;
			if (!_this.ajaxFinished) return;

			const $el = $(this);
			const attr = $el.data('attr');
			if (!attr) return;

			$(`.js-filter-option[data-attr="${attr}"]`).removeClass('is-hovered');
			$el.addClass('is-hovered');

		}).on('mouseleave', function() {
			$(this).removeClass('is-hovered');
		});
	},

	onFilterChange: function() {
		const _this = this;
		if (!_this.ajaxFinished) {
			_this.showLoading = true;
			_this.toggleImageLoader();
		} else {
			if (!_this.isProgrammaticClick) {
				_this.disableUnavailableAttributes();
			}
			_this.updateImage();
		}
	},

	getDefaults: function() {
		const _this = this;
		const skuContainer = $('.js-sku');
		if (skuContainer.length) {
			_this.defaultSku = skuContainer.text();
		}

		const oldSkuContainer = $('.js-old-sku-string');
		if (oldSkuContainer.length) {
			_this.defaultOldSkuString = oldSkuContainer.text();
		}

		const jsMainImage = $('.js-main-image').first();
		if (jsMainImage.length) {
			const imgElement = jsMainImage.find('img').first();
			_this.defaultImage = imgElement.attr('src') ?? '';
			_this.defaultImageIsPlaceholder = _this.defaultImage.includes('placeholder');
		}

		_this.hasLifestyleImages = $('.js-product-gallery-media-items .gallery-images, .js-product-gallery-popup-media-items .gallery-images').length > 0;
	},

	/**
	 * Preload images for better performance
	 */
	preloadImages: function() {
		const _this = this;

		// Collect and flatten all image URLs from `image` and `additional_images`
		const imageUrls = [...new Set(
			Object.values(_this.variantInfo)
				.flatMap(variant => {
					const urls = [];

					// Primary image
					if (variant.image && variant.image !== _this.defaultImage) {
						urls.push(variant.image);
					}

					// Additional images
					if (Array.isArray(variant.additional_images)) {
						urls.push(...variant.additional_images.filter(
							url => url && url !== _this.defaultImage
						));
					}

					return urls;
				})
		)];

		// Preload images
		imageUrls.forEach((url, index) => {
			if (!_this.preloadedImages.has(url)) {
				const img = new Image();

				img.onload = () => {
					_this.preloadedImages.set(url, img);
				};

				img.onerror = () => {
					console.warn(`Failed to preload image: ${url}`);
				};

				if (index < 3) {
					img.src = url;
				} else {
					setTimeout(() => {
						img.src = url;
					}, index * 100);
				}
			}
		});
	},

	toggleImageLoader: function() {
		if (this.showLoading) {
			$('.js-main-product-loader').addClass('is-active');
		} else {
			$('.js-main-product-loader').removeClass('is-active');
		}
	},

	hideImageLoading: function(container) {
		container.find('.image-loader').remove();
	},

	updatePopupDisabledState: function(hasRealVariantImages) {
		const _this = this;
		const hasAnyRealImages = hasRealVariantImages || _this.hasLifestyleImages;
		const popupTriggers = $('.js-product-gallery-popup-trigger');

		if (hasAnyRealImages) {
			popupTriggers.removeClass('is-disabled');
		} else {
			popupTriggers.addClass('is-disabled');
		}
	},

	updateImage: function(filtersOverride) {
		const _this = this;
		const filters = filtersOverride || _this.getActiveFilters();
		const skuWrapper = $('#sku-selection');
		const oldSkuHtml = $('.js-old-sku-string');
		const skuContainer = $('.js-sku');
		const mainImagePopup = $('.js-popup-main-image');
		const galleryContainer = $('.js-product-gallery-media-items');
		const variantImagesPopup = $('.js-product-gallery-popup-media-items');

		let matchFound = false;
		for (const attributes of Object.values(_this.variantInfo)) {
			const isMatch = Object.entries(filters).every(
				([key, value]) => attributes[key] === value
			);

			if (isMatch) {
				const newSku = attributes['sku'] ?? '';
				const oldSku = attributes['old-sku'] ?? '';
				const newImage = attributes.image ?? '';
				const additionalImages = attributes.additional_images ?? [];

				const allImages = [newImage, ...additionalImages].filter(img => img);
				let showUnavailableMessage = false;

				if (allImages.length === 0) {
					showUnavailableMessage = true;
					const fallbackImage = (_this.defaultImage && !_this.defaultImageIsPlaceholder)
						? _this.defaultImage
						: _this.placeholderImage;
					if (fallbackImage) {
						allImages.push(fallbackImage);
					}
				}

				if (galleryContainer.length) {
					// Clone the existing elements before removing (to preserve PHP-rendered HTML)
					const existingInfoDiv = galleryContainer.find('.js-unavailable-image').first().clone();
					const existingZoomIconDiv = galleryContainer.find('.product-gallery__zoom-icon').first().clone();

					galleryContainer.find('.js-variant-images-container').closest('.product-gallery__media').remove();

					const variantBlocks = [];
					allImages.forEach((imageSrc, index) => {
						if (!imageSrc) return;

						const mediaBlock = $('<div>')
							.addClass('product-gallery__media js-product-gallery-popup-trigger')
							.attr('data-index', index);

						if (index === 0 && existingInfoDiv.length) {
							const infoDiv = existingInfoDiv.clone();
							if (showUnavailableMessage) {
								infoDiv.removeClass('hidden-element');
							} else {
								infoDiv.addClass('hidden-element');
							}
							mediaBlock.append(infoDiv);
						}

						const mediaWrap = $('<div>').addClass('product-gallery__media-wrap js-cursor-container js-variant-images-container');
						const imageDiv = $('<div>').addClass('product-gallery__image media-wrap--lazy-thumb media-wrap media-wrap--700x960');
						const imgElement = $('<img>')
							.attr('src', imageSrc)
							.attr('alt', `Product variant image ${index + 1}`)
							.addClass('media-item contain-img');

						imageDiv.append(imgElement);
						mediaWrap.append(imageDiv);
						mediaBlock.append(mediaWrap);
						if (existingZoomIconDiv.length) {
							mediaBlock.append(existingZoomIconDiv.clone());
						}

						variantBlocks.push(mediaBlock);
					});

					if (variantBlocks.length) {
						galleryContainer.prepend(variantBlocks);
					}
				}

				if (variantImagesPopup.length && allImages.length) {
					variantImagesPopup.find('div').not('.js-custom-cursor').not('.gallery-images').remove();

					const wrapperDivs = allImages.map((imageSrc, index) => {
						if (!imageSrc) return;
						const wrapperDiv = $('<div>').addClass('product-gallery__image product-gallery__popup-media media-wrap--lazy-thumb media-wrap media-wrap--700x960');
						const imgElement = $('<img>').attr({
							'src': imageSrc,
							'alt': `Product variant image ${index + 1}`,
							'class': 'media-item contain-img'
						});
						wrapperDiv.append(imgElement);
						return wrapperDiv;
					});
					variantImagesPopup.prepend(wrapperDivs);
				}

				if (mainImagePopup.length) {
					mainImagePopup.attr('src', allImages[0] || _this.placeholderImage);
				}

				if (skuContainer.length) {
					skuContainer.text(newSku === '' ? _this.defaultSku : newSku);
				}

				if (oldSkuHtml.length && oldSku) {
					oldSkuHtml.text('(Replaces ' + oldSku + ')');
				} else if (oldSku) {
					skuWrapper.append('<span class="js-old-sku-string">(Replaces ' + oldSku + ')</span>');
				} else if (oldSkuHtml.length) {
					oldSkuHtml.remove();
				}

				if (skuWrapper.length) {
					const skuToAdd = newSku ? newSku : _this.defaultSku;
					skuWrapper.attr('data-product-sku', skuToAdd).data('product-sku', skuToAdd).trigger('change');
				}

				const hasRealVariantImages = allImages.some(img => img && !img.includes('placeholder'));
				_this.updatePopupDisabledState(hasRealVariantImages);

				matchFound = true;
				ProductGallery.updateStickyHeight();
				break;
			}
		}

		if (!matchFound) {
			skuContainer.text(_this.defaultSku);
			skuWrapper.attr('data-product-sku', _this.defaultSku).data('product-sku', _this.defaultSku).trigger('change');

			const fallbackImage = (_this.defaultImage && !_this.defaultImageIsPlaceholder)
				? _this.defaultImage
				: _this.placeholderImage;
			const showUnavailableMessage = !_this.defaultImage || _this.defaultImageIsPlaceholder;

			if (galleryContainer.length) {
				// Clone the existing elements before removing (to preserve PHP-rendered HTML)
				const existingInfoDiv = galleryContainer.find('.js-unavailable-image').first().clone();
				const existingZoomIconDiv = galleryContainer.find('.product-gallery__zoom-icon').first().clone();

				galleryContainer.find('.js-variant-images-container').closest('.product-gallery__media').remove();

				const mediaBlock = $('<div>')
					.addClass('product-gallery__media js-product-gallery-popup-trigger')
					.attr('data-index', 0);

				if (existingInfoDiv.length) {
					const infoDiv = existingInfoDiv.clone();
					if (showUnavailableMessage) {
						infoDiv.removeClass('hidden-element');
					} else {
						infoDiv.addClass('hidden-element');
					}
					mediaBlock.append(infoDiv);
				}

				const mediaWrap = $('<div>').addClass('product-gallery__media-wrap js-cursor-container js-variant-images-container');
				const imageDiv = $('<div>').addClass('product-gallery__image media-wrap--lazy-thumb media-wrap media-wrap--700x960');
				const imgElement = $('<img>')
					.attr('src', fallbackImage)
					.attr('alt', 'Product image')
					.addClass('media-item contain-img');

				imageDiv.append(imgElement);
				mediaWrap.append(imageDiv);
				mediaBlock.append(mediaWrap);
				if (existingZoomIconDiv.length) {
					mediaBlock.append(existingZoomIconDiv.clone());
				}

				galleryContainer.prepend(mediaBlock);
			}

			if (mainImagePopup.length) {
				mainImagePopup.attr('src', fallbackImage);
			}

			if (variantImagesPopup.length) {
				variantImagesPopup.find('div').not('.js-custom-cursor').remove();
			}

			if (_this.defaultOldSkuString) {
				oldSkuHtml.text(_this.defaultOldSkuString);
			} else {
				oldSkuHtml.remove();
			}

			const hasRealVariantImages = fallbackImage && !fallbackImage.includes('placeholder');
			_this.updatePopupDisabledState(hasRealVariantImages);
		}
	},

	disableUnavailableAttributesOnLoad: function() {
		const _this = this;
		const currentActiveFilters = _this.getActiveFilters();

		if (Object.keys(currentActiveFilters).length === 0) return;

		_this.allAttributes.forEach(attr => {
			// Skip pa_size - users should always be able to change it
			if (attr === 'pa_size') return;

			const otherFilters = {...currentActiveFilters};
			delete otherFilters[attr];

			const matchingVariants = Object.values(_this.variantInfo).filter(variant =>
				Object.entries(otherFilters).every(([key, val]) => variant[key] === val)
			);

			const availableValues = [...new Set(
				matchingVariants
					.map(variant => variant[attr])
					.filter(val => val)
			)];

			_this.updateDOMForAttribute(attr, availableValues);
		});
	},

	disableUnavailableAttributes: function() {
		const _this = this;
		if (!_this.lastChangedAttribute?.key || !_this.lastChangedAttribute?.value) return;

		// Step 1: Get currently active filters for future reference
		const currentActiveFilters = _this.getActiveFilters();

		// Step 2: Get variants that have the selected attribute value
		let matchingVariants = Object.values(_this.variantInfo).filter(variant =>
			variant[_this.lastChangedAttribute.key] === _this.lastChangedAttribute.value
		);

		// Step 3: If size hasn't changed, filter to maintain current pa_size value
		if (_this.lastChangedAttribute.key !== 'pa_size' &&
			Object.hasOwn(currentActiveFilters, 'pa_size') &&
			currentActiveFilters.pa_size) {
			matchingVariants = matchingVariants.filter(variant =>
				Object.hasOwn(variant, 'pa_size') && variant.pa_size === currentActiveFilters.pa_size
			);
		}

		if (matchingVariants.length === 0) {
			return;
		}

		// Step 3: Get all available attribute key->value pairs from matching variants
		const availableAttributes = {};

		// Collect all possible values from matching variants using _attribute_relationships
		matchingVariants.forEach(variant => {
			if (variant._attribute_relationships) {
				Object.keys(variant._attribute_relationships).forEach(attr => {
					if (!availableAttributes[attr]) {
						availableAttributes[attr] = new Set();
					}
					// Add the current variant's value for this attribute
					if (variant[attr]) {
						availableAttributes[attr].add(variant[attr]);
					}
				});
			}
		});

		// Step 3.5: Apply combination validation with fallback logic
		const validatedAttributes = {};
		Object.keys(availableAttributes).forEach(attr => {
			validatedAttributes[attr] = [];

			availableAttributes[attr].forEach(value => {
				// Create test filters with current selections + this test value
				const testFilters = {...currentActiveFilters, [attr]: value};

				// Check if any variant matches ALL these filters
				const hasValidCombination = matchingVariants.some(variant =>
					Object.entries(testFilters).every(([key, val]) => variant[key] === val)
				);

				if (hasValidCombination) {
					validatedAttributes[attr].push(value);
				}
			});

			// Fallback logic: if no valid combinations found for this attribute
			if (validatedAttributes[attr].length === 0) {
				availableAttributes[attr].forEach(value => {
					// Strategy 1: Try to find variants that match this new value + as many other current filters as possible
					let bestMatch = null;
					let maxMatches = 0;

					matchingVariants.forEach(variant => {
						if (variant[attr] === value) {
							// Count how many current filters this variant satisfies
							let matchCount = 0;
							Object.entries(currentActiveFilters).forEach(([key, val]) => {
								if (key !== attr && variant[key] === val) {
									matchCount++;
								}
							});

							if (matchCount > maxMatches) {
								maxMatches = matchCount;
								bestMatch = variant;
							}
						}
					});

					// If we found a variant with this value, add it to valid options
					if (bestMatch) {
						validatedAttributes[attr].push(value);
					}
				});

				// Strategy 2: If still empty, just use the first available value from matching variants
				if (validatedAttributes[attr].length === 0 && availableAttributes[attr].size > 0) {
					validatedAttributes[attr] = [Array.from(availableAttributes[attr])[0]];
				}
			}
		});

		// Step 4: Update DOM and handle conflicts
		_this.allAttributes.forEach(attr => {
			// Skip pa_size - users should always be able to change it
			if (attr === 'pa_size') return;

			// Skip the attribute that was just changed
			if (attr === _this.lastChangedAttribute.key) return;

			const availableValues = validatedAttributes[attr] || [];
			const currentValue = currentActiveFilters[attr];

			// Update DOM to show only available options
			_this.updateDOMForAttribute(attr, availableValues);

			// If current active filter is not in available list, deselect and auto-select first available
			if (!availableValues.includes(currentValue)) {
				_this.deselectAndSelectFirst(attr, availableValues);
			}
		});
	},

	updateDOMForAttribute: function(attr, availableValues) {
		// Handle radio buttons
		$(`.js-filter-option-radio input[name="${attr}"]`).each(function() {
			const $option = $(this);
			const $wrapper = $option.closest('.js-filter-option');
			const value = $option.val();

			if (availableValues.includes(value)) {
				$wrapper.removeClass('disabled');
				$option.prop('disabled', false);
			} else {
				$wrapper.addClass('disabled');
				$option.prop('disabled', true);
			}
		});

		// Handle option selectors (color swatches, etc.)
		$(`.js-filter-option[data-attr="${attr}"]`).each(function() {
			const $option = $(this);
			const valueContainer = $option.find('.js-span-selection');
			const value = valueContainer.data('value');

			if (availableValues.includes(value)) {
				$option.removeClass('disabled');
				if (!$option.is('option')) $option.removeClass('hidden-swatch');
			} else {
				$option.addClass('disabled');
				if (!$option.is('option')) $option.addClass('hidden-swatch');
			}
		});

		// Handle select dropdowns
		$('.product-attr-option-select').each(function() {
			const $select = $(this);
			$select.find('option').each(function() {
				const $option = $(this);
				const value = $option.val();
				const optionAttr = $option.data('attr');

				if (optionAttr !== attr) return;

				// Empty value options should always be enabled
				if (!value) {
					$option.prop('disabled', false);
					return;
				}

				if (availableValues.includes(value)) {
					$option.prop('disabled', false);
				} else {
					$option.prop('disabled', true);
				}
			});
		});
	},

	deselectAndSelectFirst: function(attr, availableValues) {
		const _this = this;

		// Handle radio buttons
		const $radioInputs = $(`.js-filter-option-radio input[name="${attr}"]`);
		if ($radioInputs.length) {
			// Deselect current
			_this.isProgrammaticClick = true;
			$radioInputs.filter(':checked').prop('checked', false);

			// Select first available
			const $firstAvailable = $radioInputs.filter(function() {
				return availableValues.includes($(this).val());
			}).first();

			if ($firstAvailable.length) {
				$firstAvailable.prop('checked', true).trigger('click');
			}
			_this.isProgrammaticClick = false;
			return;
		}

		// Handle option selectors
		const $optionSelectors = $(`.js-filter-option[data-attr="${attr}"]`);
		if ($optionSelectors.length) {
			// Deselect current
			$optionSelectors.removeClass('is-selected');

			// Select first available
			const $firstAvailable = $optionSelectors.filter(function() {
				const valueContainer = $(this).find('.js-span-selection');
				const value = valueContainer.data('value');
				return availableValues.includes(value);
			}).first();

			if ($firstAvailable.length) {
				_this.isProgrammaticClick = true;
				$firstAvailable.click();
				_this.isProgrammaticClick = false;
			}
			return;
		}

		// Handle select dropdowns
		$(`.product-attr-option-select[data-attr="${attr}"]`).each(function() {
			const $select = $(this);

			// Find first available option
			const $firstAvailable = $select.find('option').filter(function() {
				const value = $(this).val();
				return value && availableValues.includes(value);
			}).first();

			if ($firstAvailable.length) {
				_this.isProgrammaticClick = true;
				$select.val($firstAvailable.val()).trigger('change');

				if ($select.hasClass('select2-hidden-accessible')) {
					$select.trigger('change.select2');
				}
				_this.isProgrammaticClick = false;
			}
		});
	},

	getActiveFilters: function() {
		const filters = {};

		$('.js-filter-option-radio').each(function() {
			const radioButton = $(this).find('input[type="radio"]:checked').first();
			if (radioButton.length) {
				const attribute = radioButton.attr('name');
				const value = radioButton.val();
				if (attribute && value) {
					filters[attribute] = value;
				}
			}
		});

		$('#main-attr-container .js-filter-option.is-selected').each(function() {
			const attribute = $(this).data('attr');
			const valueContainer = $(this).find('.js-span-selection');
			if (valueContainer.length) {
				const value = valueContainer.data('value');
				if (value) {
					filters[attribute] = value;
				}
			}
		});

		$('#main-attr-container .js-product-attr-option-select').each(function() {
			const attribute = $(this).data('attr');
			const value = $(this).val();
			if (attribute && value) {
				filters[attribute] = value;
			}
		});

		return filters;
	},

	getVariantInfo: function() {
		const _this = this;
		const mainContainer = $('#main-attr-container');
		if (mainContainer.length > 0) {
			const productSku = mainContainer.data('product_sku');
			if (!productSku) {
				$('#main-attr-container').removeClass('is-loading');
				return;
			}

			$.ajax({
				method: 'POST',
				url: window.fwsLocalized.ajaxUrl,
				data: {
					action: 'get-variant-info',
					productSku: productSku,
				},
				success: function(response) {
					if (response.success && response.data) {
						_this.variantInfo = response.data.variants ?? [];
						_this.allAttributes = response.data.attributes ?? [];
						_this.disableUnavailableAttributesOnLoad();
						$('#main-attr-container').removeClass('is-loading');
						_this.preloadImages();
					} else {
						$('#main-attr-container').removeClass('is-loading');
					}
				},
				error: function() {
					$('#main-attr-container').removeClass('is-loading');
				},
				complete: function() {
					_this.ajaxFinished = true;
					if (_this.showLoading) {
						_this.showLoading = false;
						_this.updateImage();
					}
				},
			});
		}
	},
};

export default VariantInfo;
